import { useState } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'
import { IconContext } from 'react-icons'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { getApiErrorStatus, logApiError } from 'services/apiError'
import DropdownMenu from 'components/DropDownMenu'
import ReactTooltip from 'react-tooltip'
import NavbarData from './data' 
import useWhatsappAccess from 'hooks/useWhatsappAccess'
import { FaQuestion, FaSignInAlt, FaSignOutAlt } from 'react-icons/fa'
import cutileiLogo from 'icons/logo-cutilei-simple.png'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'

import {
  Container,
  Image,
  NavItem,
  NavButton,
  Label
} from '../styles'

export default function BusinessNavbar () {
  const [loading, setLoading] = useState (false)
  const isSigned = AuthService.isSigned ()
  const isAdmin = AuthService.isAdmin ()
  const isCompany = AuthService.isCompany ()
  const navigate = useNavigate ()
  // Gestão WhatsApp: o item só aparece para salão liberado (ver hooks/useWhatsappAccess)
  const whatsappAccess = useWhatsappAccess()

  const handleSignOut = async () => {
    const route = isAdmin ? '/admin/businesses' : (isCompany ? '/company/businesses' : '/')

    try {
      setLoading (true)

      if (!(isAdmin || isCompany)) {
        await cutileiApi.delete ('/auth/businesses', {
          headers: {
            'Authorization': `Bearer ${AuthService.getToken ()}`
          }
        })
      }

      setLoading (false)
      AuthService.businessSignOut ()
      navigate (route, { replace: true })
    } catch (error) {
      setLoading (false)
      logApiError (error)
      if (getApiErrorStatus (error) === 401) {
        AuthService.businessSignOut ()
        navigate ('/', { replace: true })
      }
    }
  }

  const renderHelpMenu = () => (
    <NavItem>
      <DropdownMenu
        id='help'
        label='Ajuda'
        position='right'
        icon={<FaQuestion/>}
        items={[
          { label: 'Política de Privacidade', path: '/privacy-policy' },
          { label: 'Termos de Uso', path: '/terms' },
          { label: 'Fale com a Cutilei', href: 'https://wa.me/message/SH5AWAQ6UP4IF1' }
        ]}
      />
    </NavItem>
  )

  return (
    <IconContext.Provider value={{color: '#252525'}}>
      <Container>
        <Image src={cutileiLogo} alt='Cutilei'/>
        {isSigned ? (
          <>
            {NavbarData.map ((item, index) => (
              AuthService.hasPermission (item.id) && (item.id !== 'whatsapp' || whatsappAccess) ? (
                <NavItem key={index}>
                  <NavLink
                    to={item.path}
                    end={item.path === '/business'}
                    className={({ isActive }) => isActive ? 'active' : ''}
                    data-for={item.id}
                    data-tip
                  >
                    {item.icon}
                  </NavLink>
                  <ReactTooltip
                    id={item.id}
                    effect='solid'
                    place='right'
                    backgroundColor='#252525'
                    tooltipRadius='10'
                  >
                    <Label>{item.label}</Label>
                  </ReactTooltip>
                </NavItem>
              ) : null)
            )}
            {renderHelpMenu ()}
            <NavItem>
              <NavButton onClick={handleSignOut} data-for='logout' data-tip>
                {loading ? (
                  <ButtonLoading style={{margin: 0}}/>
                ) : (
                  <FaSignOutAlt/>
                )}
              </NavButton>
              <ReactTooltip
                id='logout'
                effect='solid'
                place='right'
                backgroundColor='#252525'
                tooltipRadius='10'
              >
                <Label>Sair</Label>
              </ReactTooltip>
            </NavItem>
          </>
          ) : (
            <>
              <NavItem>
                <NavLink to='/login' className={({ isActive }) => isActive ? 'active' : ''}>
                  <FaSignInAlt/>
                </NavLink>
              </NavItem>
              {renderHelpMenu ()}
            </>
          )
        }
      </Container>
    </IconContext.Provider>
  )
}
